import React from 'react';
import { css, styled } from 'styled-components';
import { breakpoints } from '../styled/utils';
import { BreakpointKey, Breakpoints } from '../types';

interface ImageProps {
  alt?: string,
  className?: string,
  display?: Breakpoints,
  height?: string,
  ratioHeight?: number,
  ratioWidth?: number,
  src: string,
}

interface StyledImageProps{
  height?: string,
  $ratioHeight?: number,
  $ratioWidth?: number,
  $display?: Breakpoints,
}

const StyledImage = styled.div<StyledImageProps>`
  background-color: var(--color-iron-300);
  border-radius: var(--border-radius);
  height: ${props => props.height ? props.height : 'auto'};
  overflow: hidden;
  padding-bottom: calc((${props => (props.$ratioHeight && props.$ratioWidth) ? (props.$ratioHeight / props.$ratioWidth) : 1}) * 100%);
  position: relative;

  ${props => props.$display && Object.entries(props.$display).map(([size, value]) => css`
    @media ${breakpoints[size as BreakpointKey]} {
      display: ${value};
    }
  `)}

  > img {
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    user-select: none;
    width: 100%;
  }
`;

export default function Image({ alt, src, ratioHeight, ratioWidth, height, display }: ImageProps) {
  return (
    <StyledImage $display={display} $ratioWidth={ratioWidth || 16} $ratioHeight={ratioHeight || 9} height={height}>
      <img src={src} alt={alt} />
    </StyledImage>
  );
}
